import React from 'react';
import cn from 'classnames';
import { IIcon, useIconProps } from '../useIconProps';
import SortSvgIcon from './sort.svgrIcon.svg';
import styles from './sortIcon.module.scss';

interface SortIconProps extends IIcon {
  selected?: 'asc' | 'desc' | null | false;
}

export const SortIcon = React.forwardRef(({ selected, ...props }: SortIconProps, ref) => {
  const iconProps = useIconProps({
    ref,
    size: 20,
    ...props,
    className: cn(props.className, styles.sortIcon, {
      [styles.upSelected]: selected === 'desc',
      [styles.downSelected]: selected === 'asc',
    }),
  });

  return <SortSvgIcon {...iconProps} />;
});
